import { render, staticRenderFns } from "./DataSourceTemplate.vue?vue&type=template&id=2bd7d6b2&scoped=true&"
import script from "./DataSourceTemplate.vue?vue&type=script&lang=ts&"
export * from "./DataSourceTemplate.vue?vue&type=script&lang=ts&"
import style0 from "./DataSourceTemplate.vue?vue&type=style&index=0&id=2bd7d6b2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bd7d6b2",
  null
  
)

export default component.exports